import { IconBaseProps, IconType } from 'react-icons';
import { FaCodeBranch } from 'react-icons/fa';
import {
   HiMap,
   HiOfficeBuilding,
   HiOutlineMap,
   HiOutlineOfficeBuilding,
   HiRefresh,
   HiOutlineRefresh,
   HiOutlineGift,
   HiGift,
   HiOutlineStar,
   HiStar,
   HiDocumentRemove,
   HiOutlineDocumentRemove,
   HiOutlineCog,
   HiCog,
   HiCode,
   HiOutlineCode,
   HiOutlineClock,
   HiClock,
   HiOutlineExclamationCircle,
   HiExclamationCircle,
   HiOutlineCalendar,
   HiCalendar,
   HiOutlineCash,
   HiCash,
   HiOutlineScale,
   HiScale,
   HiOutlineShieldExclamation,
   HiShieldExclamation,
} from 'react-icons/hi';
import { TbTypography } from 'react-icons/tb';
import { HiCodeBracket, HiMapPin, HiOutlineMapPin, HiOutlineUsers, HiUsers } from 'react-icons/hi2';
import { permissionKeys, routePaths } from 'src/utils/constants';

interface VerticalNavType {
   activeIcon?: IconType;
   activeIconProps?: IconBaseProps;
   icon?: IconType;
   iconProps?: IconBaseProps;
   label: string;
   permissions?: string[];
   route: string;
}

export const verticalNavConfigs: VerticalNavType[] = [
   {
      icon: HiOutlineOfficeBuilding,
      activeIcon: HiOfficeBuilding,
      label: 'sidebar.organizations',
      route: routePaths.ADMIN.ORGANIZATION.INDEX,
   },
   {
      icon: HiOutlineMap,
      activeIcon: HiMap,
      label: 'sidebar.manageTrips',
      route: routePaths.ADMIN.MANAGE_TRIP.INDEX,
   },
   {
      icon: HiOutlineCalendar,
      activeIcon: HiCalendar,
      label: 'sidebar.programSchedules',
      permissions: [permissionKeys.READ_SCHEDULE, permissionKeys.WRITE_SCHEDULE],
      route: routePaths.ADMIN.PROGRAM_SCHEDULE.INDEX,
   },
   {
      icon: HiOutlineOfficeBuilding,
      activeIcon: HiOfficeBuilding,
      label: 'sidebar.teamHotels',
      permissions: [permissionKeys.WRITE_SCHEDULE],
      route: routePaths.ADMIN.TEAM_HOTELS,
   },
   {
      icon: HiOutlineUsers,
      activeIcon: HiUsers,
      label: 'sidebar.users',
      route: routePaths.ADMIN.USER.INDEX,
   },
   {
      icon: HiOutlineRefresh,
      activeIcon: HiRefresh,
      label: 'sidebar.transactions',
      route: routePaths.ADMIN.TRANSACTIONS.INDEX,
   },
   {
      icon: HiOutlineCash,
      activeIcon: HiCash,
      label: 'sidebar.proceedsReport',
      route: routePaths.ADMIN.PROCEEDS_REPORT.INDEX,
   },
   {
      icon: HiOutlineGift,
      activeIcon: HiGift,
      label: 'sidebar.coupon',
      route: routePaths.ADMIN.COUPON.INDEX,
   },
   {
      icon: HiOutlineStar,
      activeIcon: HiStar,
      label: 'sidebar.review',
      route: routePaths.ADMIN.REVIEW.INDEX,
   },
   {
      icon: HiOutlineDocumentRemove,
      activeIcon: HiDocumentRemove,
      label: 'sidebar.hotelBlacklist',
      route: routePaths.ADMIN.HOTEL_BLACKLIST.INDEX,
   },
   {
      icon: FaCodeBranch,
      activeIcon: FaCodeBranch,
      label: 'sidebar.siteConfigRegistry',
      route: routePaths.ADMIN.SITE_CONFIG_REGISTRY,
   },
   {
      icon: TbTypography,
      activeIcon: TbTypography,
      label: 'sidebar.fonts',
      route: routePaths.ADMIN.FONTS,
   },
   {
      icon: HiOutlineClock,
      activeIcon: HiClock,
      label: 'sidebar.activityLogs',
      route: routePaths.ADMIN.ACTIVITY_LOGS,
   },
   {
      icon: HiOutlineExclamationCircle,
      activeIcon: HiExclamationCircle,
      label: 'sidebar.bookingFailureTracker',
      route: routePaths.ADMIN.BOOKING_FAILURE_TRACKER.INDEX,
   },
   {
      icon: HiOutlineScale,
      activeIcon: HiScale,
      label: 'sidebar.disputes',
      route: routePaths.ADMIN.DISPUTES,
   },
   {
      icon: HiOutlineShieldExclamation,
      activeIcon: HiShieldExclamation,
      label: 'sidebar.fraudWatch',
      permissions: [permissionKeys.PLATFORM_ADMIN],
      route: routePaths.ADMIN.FRAUD_WATCH.INDEX,
   },
   {
      icon: HiOutlineMapPin,
      activeIcon: HiMapPin,
      label: 'sidebar.touristOverride',
      route: routePaths.ADMIN.TOURIST_OVERRIDE,
   },
];
